import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    events: [],
    loadingEvents: false,
    loadingEventsVideo: false,
    responseListEventsVideo: [],
    oadingStatuses: false,
    statuses: [],
};

const route = 'modules/driverPerformance/views/events/modals/advancedFilters/redux/slice';

export const getDriverPerformanceEventSearchEvents = createAsyncThunk('driverPerformance/advancedFilters/searchEvents', async (payload, { rejectWithValue, getState }) => {
    try {

        const response = await clientQuery(`
            query ($conditions: [EventSearchInput], $sort: [EventSortInput], $limit: Int, $offset: Int) {
                data: searchEvents(
                    conditions: $conditions
                    sort: $sort
                    limit: $limit
                    offset: $offset
                ) {
                    total
                    items {
                        id
                        eventName
                        diagnostic
                        color
                        type
                        category
                    }
                }
            }
        `,
            {
                conditions: [
                    {
                        fields: "type",
                        terms: ["risk"],
                        exact: true,
                    }
                ],
                sort: [
                    {
                        field: "eventName",
                        order: "ASC",
                    },
                ],
                limit: 1000,
                offset: 0,
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        return response?.data?.items.length ? response?.data?.items.map((item) => ({ id: item?.eventName, name: item?.eventName })) : []

    } catch (exc) {
        ExceptionManager(exc, route, 'searchEvents');
        return rejectWithValue(exc);
    }
});

export const getDriverPerformanceHasVideoEvents = createAsyncThunk('driverPerformance/advancedFilters/searchHasVideoEvents', async ({ }, { rejectWithValue, dispatch }) => {
    try {

        const result = await clientQuery(`
                query getListHasVideoEvents {
                    data: getListHasVideoEvents {
                        eventName
                        rawEvents
                    }
                }`,
            {},
            endpoints.GRAPHQL_GENERAL_V2
        )

        return result?.data || [];
    } catch (exc) {
        console.log('Error fetching video events:', exc)
        return rejectWithValue(exc)
    }
});

export const getDriverPerformanceEventSearchStatuses = createAsyncThunk('driverPerformance/advancedFilters/searchStatuses', async (payload, { rejectWithValue, getState }) => {
    try {

        const body = {
            conditions: [
                {
                    fields: ["entityName"],
                    terms: ["eventStatus"],
                },
            ],
            limit: 100,
            offset: 0,
            sort: [{ field: "label", order: "ASC" }],
        };

        const response = await clientQuery(
            `query searchEntityLists ($conditions: [EntityListSearchInput], $sort: [EntityListSortInput], $limit: Int, $offset: Int) {
                    data: searchEntityLists (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            entityId
                            entityName
                            parentId
                            label
                            value1
                            value2
                        }
                        total
                    }
                }`,
            body,
            endpoints.GRAPHQL_GENERAL_V2
        );

        return response?.data?.items || [];


    } catch (exc) {
        return rejectWithValue(exc.message);
    }
});

//Slice
const driverPerformanceEventsTabAdvancedFiltersRedux = createSlice({
    name: "driverPerformance/advancedFilters",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalAdvancedFilters: (state, action) => {
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //getDriverPerformanceHasVideoEvents
        builder.addCase(getDriverPerformanceHasVideoEvents.pending, (state) => {
            state.loadingEventsVideo = true;
            state.error = null;
        });
        builder.addCase(getDriverPerformanceHasVideoEvents.fulfilled, (state, action) => {
            state.loadingEventsVideo = false;
            state.responseListEventsVideo = action.payload;
        });
        builder.addCase(getDriverPerformanceHasVideoEvents.rejected, (state, action) => {
            state.loadingEventsVideo = false;
            state.error = action.payload;
        });

        //getDriverPerformanceEventSearchStatuses
        builder.addCase(getDriverPerformanceEventSearchStatuses.pending, (state, action) => {
            state.loadingStatuses = true;
        })
        builder.addCase(getDriverPerformanceEventSearchStatuses.fulfilled, (state, action) => {
            state.loadingStatuses = false;
            state.statuses = action.payload;
        })
        builder.addCase(getDriverPerformanceEventSearchStatuses.rejected, (state, action) => {
            state.loadingStatuses = false;
            state.error = action.payload;
        })
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceEventsTabAdvancedFiltersRedux;

// Extract and export each action creator by name
export const { openModalAdvancedFilters, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
